import React from 'react';

import { LOAN_AMOUNT } from '../../constants/LoansCalculator';

import './LoanAmount.css';

export const LoanAmount = ({ loanAmountValue }) => {
  return (
    <div className="loan-amount-wrapper">
      <div>{LOAN_AMOUNT}</div>
      <div>$ {loanAmountValue}</div>
    </div>
  );
};
